import {BehaviorSubject, Observable} from "rxjs";
import {ConcreteHierarchyItemInterface} from "./ConcreteHierarchyItemInterface";
import {MapPosition} from "../../models/MapPosition";
import {ObjectConfig} from "../../models/ObjectConfig";
import {Rectangle} from "cesium";
import {Overlay} from "../../services/overlay/Overlay";

export class ConcreteLayer implements ConcreteHierarchyItemInterface {

  public id = null;
  public title;
  public parentItemId = null;
  public parentConcreteId = null;
  public bgImageUrl = null;
  public children: Map<string, ConcreteHierarchyItemInterface> = new Map<string, ConcreteHierarchyItemInterface>();
  public zIndex = 0;
  public group = null;
  public bgColor = null;
  public objectConfig: ObjectConfig = null;
  // {
  //   fillColor: "#000",
  //   fillOpacity: 0.4,
  //   strokeColor: "#000",
  //   strokeWeight: 2,
  //   latLngs: []
  // };

  protected figure = null;

  protected childrenObservable: Observable<ConcreteHierarchyItemInterface[]>;
  protected childrenObservable$: BehaviorSubject<ConcreteHierarchyItemInterface[]> = new BehaviorSubject<ConcreteHierarchyItemInterface[]>([]);
  private view;

  public overlay: Overlay = null;
  public get isOverlay(): boolean { return !!this.overlay; }

  constructor(title?) {
    this.title = title;
    this.objectConfig = new ObjectConfig();
  }

  public static fromConfig(config): ConcreteLayer {
    let cl = new ConcreteLayer(config.title);
    cl.id = config.id;
    cl.parentItemId = config.parent_object_id;
    cl.parentConcreteId = config.parent_concrete_id;
    cl.bgImageUrl = config.bg_image;
    cl.bgColor = config.bg_color;
    cl.zIndex = config.z_index;
    cl.group = config.group || null;
    cl.objectConfig.assign(config.map_overlay_config);
    return cl;
  }

  public static fromOverlay(overlay: Overlay): ConcreteLayer {
    let name = overlay.name;
    // if (overlay.group) {
    //   name = '[' + overlay.group + '] ' + name;
    // }
    let cl = new ConcreteLayer(name);
    cl.id = -1 * overlay.getId() - 100;
    cl.parentItemId = null;
    cl.parentConcreteId = null;
    cl.bgImageUrl = null;
    cl.bgColor = null;
    cl.zIndex = 1;
    cl.group = overlay.group;
    cl.overlay = overlay;
    return cl;
  }

  getParentConcreteId(){
    return this.parentConcreteId;
  }

  getParentItemId(){
    return this.parentItemId;
  }

  public getParentGroupId(){
    return this.group;
  }

  getGroup(){
    return this.group;
  }

  public asSimpleObject() {
    return {
      id: this.id,
      title: this.title,
      bg_image: this.bgImageUrl,
      bg_color: this.bgColor,
      z_index: this.zIndex,
      parent_concrete_id: this.parentConcreteId,
      parent_object_id: this.parentItemId,
      map_overlay_config: this.objectConfig.asSimpleObject()
    };
  }

  public updateFromConfig(config) {
    if (!this.id) { this.id = config.id; }
    this.title = config.title;
  }

  public getIconUrl(): string {
    return null;
  }

  public getTitle(): string {
    return this.title;
  }

  public setTitle(val:string){
    this.title = val;
  }

  public getCHIId(): string {
    if (this.isOverlay) {
      return "Overlay-" + (this.id ? this.id : 'TOP');
    }
    return "ConcreteLayer-" + (this.id ? this.id : 'TOP');
  }

  public getSort(): number {
    return 1;
  }

  public addChild(item: ConcreteHierarchyItemInterface): void {
    this.children.set(item.getCHIId(), item);
  }

  public removeChild(item: ConcreteHierarchyItemInterface): void {
    this.children.delete(item.getCHIId());
  }

  // public getParent() {
  //   throw new Error('Not implemented');
  //   return new ConcreteLayer();
  // }

  public onSelect() {
    // hide/show objects
  }

  public getChildren(): Observable<ConcreteHierarchyItemInterface[]> {
    return this.childrenObservable$.asObservable();
  }

  public setChildren(observable: Observable<ConcreteHierarchyItemInterface[]>) {
    // this.childrenObservable = observable;
    observable.subscribe(d => this.childrenObservable$.next(d));
  }

  public setBgImageUrl(url: string): void {
    this.bgImageUrl = url;
  }

  public setPositions(positions: MapPosition[]) {
    this.objectConfig.setLatLngs(positions);
  }

  getRectangleView(): Rectangle{

    if (this.isOverlay) {
      let pos = [];
      pos.push(Cesium.Cartographic.fromDegrees(this.overlay.left_top_lon, this.overlay.left_top_lat, 10000));
      pos.push(Cesium.Cartographic.fromDegrees(this.overlay.right_bottom_lon, this.overlay.right_bottom_lat, 10000));
      return Cesium.Rectangle.fromCartographicArray(pos);
    }

    // let center=null;
    if (!this.objectConfig.getPositions()){
      return null;
    }
    let pos = [];

    this.objectConfig.getPositions().forEach((item:MapPosition, index,arr)=>{
      pos.push(Cesium.Cartographic.fromDegrees(item.longitude, item.latitude, item.height+10000));
    //   // if (!center) {
    //   //   center = {latitude: item.latitude / arr.length, longitude: item.longitude / arr.length}
    //   // }
    //   // else{
    //   //  center.latitude+= item.latitude / arr.length;
    //   //  center.longitude+= item.longitude / arr.length;
    //   // }
    });
    return Cesium.Rectangle.fromCartographicArray(pos);
  }
}


